<template>
  <div>
    <Subheader :title="editingGoal ? 'Edit Goal' : 'New Goal'" />

    <div class="app-content-column">
      <EditGoalCard :goal="goal" />

      <div class="button-wrapper is-centered">
        <button class="large-button" @click="submitGoal">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import EditGoalCard from '@/components/EditGoalCard'

import Goal from '@/services/goals'
import { validateInputLength } from '@/services/forms'
import moment from 'moment'

export default {
  name: 'EditGoal',
  components: {
    Subheader,
    EditGoalCard,
  },
  data() {
    return {
      editingGoal: false,
      goalId: '',
      projectId: '',
      goal: {},
      loading: false,
    }
  },
  created() {
    this.projectId = this.$route.params.projectId
    this.goalId = this.$route.params.goalId
    if (this.goalId) {
      //if editing existing goal, fetch goal
      this.editingGoal = true
      this.refreshData()
    } else {
      //otherwise create new goal
      this.goal = {
        ...Goal.create(),
        project: this.projectId,
        targetFunds: '',
        startDate: moment().format('YYYY-MM-DDTHH:mm'),
        fieldErrors: [],
      }
    }
  },
  methods: {
    refreshData() {
      Goal.api.get(this.goalId).then(data => {
        this.goal = {
          ...Goal.create(data),
          endDate: this.dateFormatForUI(data.endDate),
          fieldErrors: [],
        }
      })
    },
    dateFormatForUI(date) {
      // date => 2019-08-13T12:00:00Z (how date is stored in db)
      // dateFormatForUI => 2019-08-13T12:00 (need it to be this to render properly on UI)

      //accounting for error "Invalid date" if endDate is unable to be coerced into specified format
      //will reset endDate to null if error occurs
      const dateFormatForUI = moment(date).format('YYYY-MM-DDTHH:mm')
      if (!dateFormatForUI || dateFormatForUI === 'Invalid date') {
        return null
      } else {
        return dateFormatForUI
      }
    },
    submitGoal() {
      this.collectFieldErrors()

      if (!this.goal.fieldErrors.length) {
        if (this.editingGoal) {
          this.updateGoal()
        } else {
          this.createNewGoal()
        }
      }
    },
    updateGoal() {
      const updatedGoal = Goal.create(this.goal)

      const fields = ['title', 'description', 'endDate', 'title', 'targetFunds']
      Goal.api.update(updatedGoal, fields).then(() => {
        this.$Alert.alert({
          type: 'success',
          message: `<h2>Goal Updated</h2>`,
          timeout: 3000,
        })
        this.$router.push({ name: 'GoalList', params: { projectId: this.projectId } })
      })
    },
    createNewGoal() {
      const newGoal = Goal.create(this.goal)
      Goal.api.create(newGoal).then(() => {
        this.$Alert.alert({
          type: 'success',
          message: `<h2>Goal Submitted</h2>`,
          timeout: 3000,
        })
        this.$router.push({ name: 'GoalList', params: { projectId: this.projectId } })
      })
    },
    collectFieldErrors() {
      //client-side validation
      this.goal.fieldErrors = []

      Object.keys(this.goal).forEach(field => {
        if (
          field === 'targetFunds' ||
          field === 'endDate' ||
          field === 'title' ||
          field === 'description'
        ) {
          const error = validateInputLength(field, this.goal[field])
          if (error) {
            this.goal.fieldErrors.push(error)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/layout';
@import '../styles/forms';

/* TODO: Refactor search-card into a modifier for card */
.search-card {
  @include card-w-borders();
  align-items: center;
  text-align: center;
}

.large-button {
  @include small-button-orange();
  margin: 0 auto;

  @media only screen and (max-width: $mobile-smallest-width) {
    width: 15rem;
  }
}

.center-div {
  width: 100%;
  text-align: center;
}

.card {
  @include card-w-borders();
  align-items: center;
  margin-top: 1.25rem;
}

.amount-container label {
  float: left;
  margin-right: 0.5rem;
}

.amount-container div {
  overflow: hidden;
}

.amount-container input {
  display: block;
}
</style>
